import { AppConfig } from 'config'

export const VisitKnowledgeBase = () => {
	return (
		<a
			href={AppConfig.KNOWLEDGEBASE_URL}
			target="_blank"
			rel="noopener noreferrer"
			className="flex items-center justify-center gap-2 text-brand text-[14px] leading-[18px] hover:text-t-email-blue transition-colors cursor-pointer"
		>
			<svg
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM8 14.4C4.46538 14.4 1.6 11.5346 1.6 8C1.6 4.46538 4.46538 1.6 8 1.6C11.5346 1.6 14.4 4.46538 14.4 8C14.4 11.5346 11.5346 14.4 8 14.4Z"
					fill="currentColor"
				/>
				<path
					d="M8 4.8C7.33726 4.8 6.8 5.33726 6.8 6C6.8 6.66274 7.33726 7.2 8 7.2C8.66274 7.2 9.2 6.66274 9.2 6C9.2 5.33726 8.66274 4.8 8 4.8ZM8 8.8C7.44772 8.8 7 9.24772 7 9.8V11.2C7 11.7523 7.44772 12.2 8 12.2C8.55228 12.2 9 11.7523 9 11.2V9.8C9 9.24772 8.55228 8.8 8 8.8Z"
					fill="currentColor"
				/>
			</svg>
			<span>Visit our knowledge base</span>
		</a>
	)
}
